import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import Youtube from 'react-youtube';
import classNames from "classnames";

import { getParameterByName } from '../../helpers/location';
import imgPreview from './imgPreview.png';

import './index.css';

class NotificationPreview extends React.Component {
    state = {
        lang: 'fr-FR',
    };

    toggleLang(lang) {
        this.setState({ lang });
    }

    render() {
        const { lang } = this.state;
        const { data } = this.props;
        const vidOpts = {
            width: '250',
            height: '200px',
            playerVars: {
                frameBorder: 0,
                allowFullScreen: 0,
                rel: 0,
                enablejsapi: 0,
                autoplay: 0,
                showinfo: 0,
                loop: 0,
                iv_load_policy: 3,
                start: 1,
            },
        };
        if (data.localization
            && data.localization[lang]
            && data.localization[lang].videoId
            && getParameterByName('t', data.localization[lang].videoId)) {
            vidOpts.playerVars.start = parseInt(getParameterByName('t', data.localization[lang].videoId), 10);
        }
        return (
            <div id="notificationPreview" className="col-md-6">
                <div className="inline lang">
                    <button
                        className={classNames('btn btn-box-tool', { selected: lang === 'fr-FR'})}
                        onClick={() => this.toggleLang('fr-FR')}
                    >
                        <span className="flag-icon flag-icon-fr"/>
                    </button>
                    <button
                        className={classNames('btn btn-box-tool', { selected: lang === 'en-GB' })}
                        onClick={() => this.toggleLang('en-GB')}
                    >
                        <span className="flag-icon flag-icon-gb"/>
                    </button>
                    <button
                        className={classNames('btn btn-box-tool', { selected: lang === 'es-ES' })}
                        onClick={() => this.toggleLang('es-ES')}
                    >
                        <span className="flag-icon flag-icon-es"/>
                    </button>
                </div>
                <div className="previewContainer">
                    <img src={imgPreview} alt="" width="320"/>
                    <div className="contentContainer">
                        <div className="title">
                            {data.localization && data.localization[lang] && data.localization[lang].title}
                        </div>
                        <div className="date">
                            {data.notificationDate && moment(data.notificationDate).fromNow()}
                        </div>
                        <div
                          dangerouslySetInnerHTML={{ __html: data.localization && data.localization[lang] && data.localization[lang].description }}
                        />
                        {data.localization && data.localization[lang] && data.localization[lang].imageUrl && (
                            <div style={{ textAlign: 'center' }}>
                                <img className="picture" src={data.localization && data.localization[lang] && data.localization[lang].imageUrl} alt="" />
                            </div>
                        )}
                        {data.localization && data.localization[lang] && data.localization[lang].videoId && (
                            <div style={{ textAlign: 'center', margin: '20px 0' }}>
                                <Youtube videoId={data.localization[lang].videoId} id="ytplayer" opts={vidOpts} />
                            </div>
                        )}
                        {data.localization && data.localization[lang] && data.localization[lang].button && data.localization[lang].button.text && (
                            <div style={{ textAlign: 'center' }}>
                                <button className="button">{data.localization[lang].button.text}</button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    state => ({ state }),
    dispatch => ({ dispatch }),
    null,
    { pure: false }
)(NotificationPreview);



// WEBPACK FOOTER //
// ./src/pages/Notifications/NotificationPreview.js